// store/maintenance/maintenanceSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { fetchMaintenance } from "../actions/maintenanceActions";

const initialState = {
  maintenance: [],     
  loading: false,
  error: null,
  isActive: false, 
};

const maintenanceSlice = createSlice({
  name: "maintenance",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMaintenance.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMaintenance.fulfilled, (state, action) => {
        state.loading = false;
        state.maintenance = action.payload;
        state.isActive =
          Array.isArray(action.payload) &&
          action.payload[0]?.maintenanceIsActive === true;
      })
      .addCase(fetchMaintenance.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
        state.isActive = false;
      });
  },
});

// selectors
export const selectMaintenanceData = (state) => state.maintenance.maintenance;
export const selectMaintenanceLoading = (state) => state.maintenance.loading;
export const selectMaintenanceError = (state) => state.maintenance.error;
export const selectIsMaintenanceActive = (state) => state.maintenance.isActive;
export const selectMaintenanceDetails = (state) => state.maintenance.maintenance?.[0];

export default maintenanceSlice.reducer;
